// Donder wishlist — localStorage based, syncs across tabs
(function () {
  const STORAGE_KEY = 'donder_wishlist_v1';

  function getList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      // Broadcast change to all listeners in this tab
      document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: list }));
    } catch (e) {
      console.warn('Wishlist save failed:', e);
    }
  }

  function isInList(handle) {
    return getList().some(function (item) { return item.handle === handle; });
  }

  function addItem(handle, id) {
    const list = getList();
    if (list.some(function (i) { return i.handle === handle; })) return list;
    list.push({ handle: handle, id: id, addedAt: Date.now() });
    saveList(list);
    return list;
  }

  function removeItem(handle) {
    const list = getList().filter(function (i) { return i.handle !== handle; });
    saveList(list);
    return list;
  }

  function toggle(handle, id) {
    return isInList(handle) ? removeItem(handle) : addItem(handle, id);
  }

  function updateCount() {
    const count = getList().length;
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function syncButtonStates() {
    document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      const handle = btn.dataset.productHandle;
      const isIn = isInList(handle);
      btn.classList.toggle('is-in-wishlist', isIn);
      btn.setAttribute('aria-pressed', isIn ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        isIn ? 'Verwijder uit wishlist' : 'Toevoegen aan wishlist'
      );
    });
  }

  function bindButtons() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.js-wishlist-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.productHandle;
      const id = btn.dataset.productId;
      toggle(handle, id);
    });
  }

  function listenForChanges() {
    document.addEventListener('wishlist:changed', function () {
      updateCount();
      syncButtonStates();
    });
    // Cross-tab sync
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        updateCount();
        syncButtonStates();
      }
    });
  }

  function init() {
    bindButtons();
    listenForChanges();
    updateCount();
    syncButtonStates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose minimal API for the wishlist page
  window.DonderWishlist = {
    getList: getList,
    isInList: isInList,
    remove: removeItem,
    add: addItem,
    toggle: toggle
  };
  /* --- Donder wishlist cross-device sync (vereist backend /apps/donder/wishlist) --- */
  (function () {
    if (!window.DonderCustomerId) return; // alleen voor ingelogde klanten
    var syncTimer = null;

    function pushRemote(list) {
      fetch('/apps/donder/wishlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: list })
      }).catch(function () {});
    }

    // 1) Bij laden: remote ophalen, samenvoegen met lokaal, beide bijwerken
    fetch('/apps/donder/wishlist')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (remote) {
        if (!remote || !Array.isArray(remote.items)) return;
        var local = getList();
        var byHandle = {};
        remote.items.concat(local).forEach(function (i) {
          if (i && i.handle && !byHandle[i.handle]) byHandle[i.handle] = i;
        });
        var merged = Object.keys(byHandle).map(function (h) { return byHandle[h]; });
        if (merged.length !== local.length) saveList(merged);
        if (merged.length !== remote.items.length) pushRemote(merged);
      })
      .catch(function () {});

    // 2) Bij elke wijziging: debounced naar remote
    document.addEventListener('wishlist:changed', function (e) {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () { pushRemote(e.detail || getList()); }, 800);
    });
  })();

})();
